import * as React from 'react';
import classNames from 'classnames';
import { TButton } from './Button.types';
import './Button.styles.scss';

export const Button: TButton = ({
  children,
  color = 'primary',
  variant = 'contained',
  size = 'medium',
  fullWidth = false,
  startIcon,
  endIcon,
  loading = false,
  sx,
  component = 'button',
  className,
  disabled = false,
  type = 'button',
  style,
  ...props
}) => {
  const isDisabled = disabled || loading;
  const Component = component;
  const label = loading ? 'Loading...' : children;
  const hasLabel = Boolean(label);

  return (
    <Component
      className={classNames(
        'button',
        `button--${variant}`,
        `button--size-${size}`,
        `button--color-${color}`,
        {
          [`button--full-width`]: fullWidth,
          [`button--loading`]: loading,
        },
        className
      )}
      {...(component === 'button' ? { disabled: isDisabled, type } : {})}
      style={{ ...style, ...sx }}
      {...props}
    >
      {startIcon ? (
        <span className={`button__icon button__icon--start`}>{startIcon}</span>
      ) : null}
      {hasLabel ? <span className={`button__label`}>{label}</span> : null}
      {endIcon ? (
        <span className={`button__icon button__icon--end`}>{endIcon}</span>
      ) : null}
    </Component>
  );
};
